module.exports = __webpack_public_path__ + "img/banner22.668b945d.jpg";